export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5037.b02de45b.jpg";